export const params = {
  viewBoxMobile: {
    start: [971, 0, 428, 930],
    end: [971, 398, 428, 178],
  },
  viewBoxDesktop: {
    start: [0, 0, 2500, 929],
    end: [0, 371, 2500, 227],
  },
  markers: [
    {
      id: 'vestbredden',
      text: 'VESTBREDDEN',
      params: {
        mobile: {
          text: [1212, 435.18],
          marker: [1266.56, 449.5],
          line: 'M1144 499.918L1266.5 449.5',
        },
      },
    },
    {
      id: 'israel',
      text: 'ISRAEL',
      params: {
        mobile: {
          text: [1185, 563.18],
          marker: [1209.56, 535.5],
          line: 'M1140.3 502.598L1210 535.5',
        },
      },
    },
    {
      id: 'gaza',
      text: 'GAZA',
      params: {
        mobile: {
          text: [1077, 508.18],
          marker: [1139.56, 502.5],
        },
      },
    },
  ],
}
